<template>
  <f7-page name="uhrny-zrazok" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Úhrny zrážok</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="zrazky-legenda-wrap">
      <img src="static/shmu/img/zrazky_legenda.jpg" class="zrazky-legenda">
    </div>

    <div class="zrazky-dt" v-if="zrazkyGeoJsonDt">
      24h. úhrn k {{ zrazkyGeoJsonDt*1000 | moment('DD.MM.YYYY HH:mm') }}
    </div>


    <l-map :zoom="zoom"
           :center="center"
           :options="mapOptions"
           ref="mapZrazky"
           class="zrazky-map"
    >
      <l-control-zoom position="bottomright"  ></l-control-zoom>
      <l-tile-layer
          ref="layerBg"
          :url="url"
          :attribution="attribution"
      />
      <l-tile-layer :url="borderUrl" />
      <l-tile-layer :url="riversUrl" :opacity="0.5" />
      <l-marker-cluster :options="clusterOptions" ref="clusterRef">
        <l-geo-json v-for="geoJson in zrazkyGeoJsonData.features" :key="geoJson.id" :geojson="geoJson" :options="zrazkyGeoJsonOptions"></l-geo-json>
        <!--l-geo-json
                ref="geoJsonRef"
                :geojson="zrazkyGeoJsonData"
                :options="zrazkyGeoJsonOptions"
        /-->
      </l-marker-cluster>

      <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
        </div>
      </l-control>

      <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
        </div>
      </l-control>


    </l-map>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson,  LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";

var zra_icn_markers = [];
var zra_div_markers = [];

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl,
    'l-marker-cluster': Vue2LeafletMarkerCluster
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      isGeoJsonLoaded: false,
      zrazkyGeoJsonDt: null,
      zrazkyGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zrazkyGeoJsonOptions: {
        onEachFeature:this.openZrazkyDetailFromFeature,
        pointToLayer: this.makeZrazkyPoint,
      },
      clusterOptions: {
        disableClusteringAtZoom: 9,
        zoomToBoundsOnClick: false,
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: false,
        iconCreateFunction: cluster => {

          let vals = [];
          cluster.getAllChildMarkers().forEach( marker => {
            let val = marker.feature.properties.RR24H;
            if (val !== null) {
              vals.push(val)
            }
          });

          let class_name = 'cluster-base-color';

          if (vals.length > 0) {
            let avg = vals.reduce((a, b) => a + b, 0);
            let highest = vals.sort((a, b) => b - a)[0];
            class_name = this.getColorClass(highest);
          }


          let pocet = cluster.getChildCount();
          let p_text = 'staníc';
          if (pocet === 1) p_text = 'stanica';
          if (pocet > 1) p_text = 'stanice';
          if (pocet >= 5) p_text = 'staníc';
          return L.divIcon({
            className: 'cluster-icon ' + class_name,
            iconSize: 45,
            html: pocet + '&nbsp; <small style="font-weight:normal; font-size:8px;">'+p_text+'</small>',
          });
        },
      },
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 8,
      center: latLng(48.588714, 17.896843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },


    };
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadZrazkyGeoJsonData();
      }

    },
    loadZrazkyGeoJsonData: function() {
      const self = this;
      //console.log('loadZrazkyGeoJsonData')

      let cached_geojson = self.$ls.get('precipitation_geojson');
      if (cached_geojson !== null) {
        self.zrazkyGeoJsonData = Object.freeze(cached_geojson);
        self.isGeoJsonLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'precipitation/getgeojson', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.zrazkyGeoJsonData = Object.freeze(response.data);
                self.isGeoJsonLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('precipitation_geojson', self.zrazkyGeoJsonData, 10 * 60 * 1000); //  10 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o úhrne zrážok', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    getStationById: function(station_id) {
      if (this.stations) {
        return this.stations.find((item) => item.base_id === station_id)
      }
      return false;
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapZrazky.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapZrazky.mapObject);

      /*
                      setTimeout(function() {
                        console.log(self.$refs.clusterRef);
                        self.$refs.clusterRef.mapObject.refreshClusters();
                      }, 1000);
      */




    },
    makeZrazkyPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      /*
      let map = this.$refs.mapZrazky.mapObject;
      let myIcon = L.divIcon({className: 'i-label', html:props.name, iconAnchor:[100,30]});
      zra_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      zra_icn_markers[feature.id]._icon.id = feature.id;
       */

      let color_class = '';
      let val = props.RR24H;

      if (val === null) return;

      this.zrazkyGeoJsonDt = props.dt;

      color_class = this.getColorClass(val);



      let divIcon = L.divIcon({className: 'precip-box ' + color_class, html:val, iconAnchor:[30,0]});
      //zra_div_markers[feature.id] = L.marker(latlng, {icon: divIcon}).addTo(map);
      zra_div_markers[feature.id] = L.marker(latlng, {icon: divIcon});
      // zra_div_markers[feature.id]._icon.id = feature.id;


      return zra_div_markers[feature.id];
    },
    openZrazkyDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          self.$f7router.navigate('/uhrny-zrazok/' + v.target.feature.id);
        }
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    getColorClass(val) {
      let color_class = '';
      if (val < 1) color_class = 'precip-0-1';
      else if (val < 5) color_class = 'precip-1-5';
      else if (val < 10) color_class = 'precip-5-10';
      else if (val < 20) color_class = 'precip-10-20';
      else if (val < 35) color_class = 'precip-20-35';
      else if (val < 50) color_class = 'precip-35-50';
      else if (val < 70) color_class = 'precip-50-70';
      else if (val < 90) color_class = 'precip-70-90';
      else color_class = 'precip-90plus';
      return color_class;
    },


    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapZrazky.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapZrazky.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapZrazky.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }


  }

};
</script>

<style lang="scss">
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

/* Landscape phone to landscape tablet */
@media (max-width: 979px) {
  .zrazky-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
    left: 0;
    img {
      max-width: 100%;
      height:auto;
    }
  }
}

/* Small desktop */
@media (min-width: 980px)  {
  .zrazky-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: calc(var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px));;
    left: 50%;

    .zrazky-legenda {
      position:relative;
      left:-50%;
      max-width: 100%;
      height: auto;
      z-index: 1000;
    }
  }
}


.zrazky-map {
  width: 100%;
  height: 100%;
}

.i-label2 {
  font-weight: bold;
  color:white;
}

.precip-box {
  width: 30px !important;
  height: 15px !important;
  border: 1px solid #8d8d8d;
  background-color: rgba(255,255,255,0.8);
  font-size: 12px;
  line-height: 15px !important;
  color:black;
  text-align: center;
}

.precip-0-1 {
  background-color: rgba(255,255,255,0.8);
  color: black !important;
}
.precip-1-5 {
  background-color: rgba(204,204,204,0.8);
  color: black !important;
}
.precip-5-10 {
  background-color: rgba(204,255,153,0.8);
  color: black !important;
}
.precip-10-20 {
  background-color: rgba(102,204,255,0.8);
  color: black !important;
}
.precip-20-35 {
  background-color: rgba(0,102,204,0.8);
  color: white !important;
}
.precip-35-50 {
  background-color: rgba(0,0,204,0.8);
  color: white !important;
}
.precip-50-70 {
  background-color: rgba(255,102,102,0.8);
  color: white !important;
}
.precip-70-90 {
  background-color: rgba(255,0,5,0.8);
  color: white !important;
}
.precip-90plus{
  background-color: rgba(152,32,104,0.8);
  color: white !important;
}

.zrazky-toolbar {
  text-align: center;
  font-size:0.8em;
  width:100%;
  margin:0;
  padding: 0;
}

.zrazky-dt {
  font-size:12px;
  position: absolute;
  bottom: 3px;
  left: 3px;
  background: rgba(255,255,255,0.7);
  color: black;
  padding: 3px 7px;
  border: 1px solid #e2e2e2;
  z-index:1001;
}

.cluster-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(48, 72, 107, 0.3);
  font-size: 1em;
  font-weight: bold;
}

.cluster-base-color {
  background: rgba(255, 255, 255, 0.9);
  color: #000;
}


</style>
